module.exports = __webpack_public_path__ + "img/ic_probetraining.c3c49175.svg";